/**
 * Fera reviews: remove any review with less than 4 stars from the DOM.
 * Handles delayed load (Fera injects content asynchronously) via
 * MutationObserver and a short retry window.
 */
(function () {
  var MIN_STARS = 4;
  var MIN_VISIBLE_REVIEWS = 4;

  function injectFeraGridStyles() {
    if (document.getElementById('fera-reviews-handler-styles')) return;
    var style = document.createElement('style');
    style.id = 'fera-reviews-handler-styles';
    style.textContent = '.fera-productReviews--grid .fera-productReviews-reviews { justify-content: flex-start !important; }';
    (document.head || document.documentElement).appendChild(style);
  }

  function getReviewRating(reviewEl) {
    var stars = reviewEl.querySelector('.fera-productReviews-review-stars[data-rating], .fera-stars[data-rating], [data-rating]');
    if (!stars) return null;
    var raw = stars.getAttribute('data-rating');
    if (raw == null || raw === '') return null;
    var num = parseFloat(raw, 10);
    return isNaN(num) ? null : num;
  }

  function removeLowRatedFeraReviews() {
    var containers = document.querySelectorAll('.fera-productReviews-reviews');
    containers.forEach(function (container) {
      var reviews = container.querySelectorAll('.fera-productReviews-review');
      reviews.forEach(function (review) {
        var rating = getReviewRating(review);
        if (rating !== null && rating < MIN_STARS) {
          review.remove();
        }
      });
    });
  }

  function clickShowMoreIfNeeded() {
    var containers = document.querySelectorAll('.fera-productReviews-reviews');
    containers.forEach(function (container) {
      var visibleCount = container.querySelectorAll('.fera-productReviews-review').length;
      if (visibleCount >= MIN_VISIBLE_REVIEWS) return;
      var block = container.closest('.fera-productReviews--grid') || container.closest('[class*="fera-productReviews"]') || document.body;
      var showMore = block.querySelector('.fera-productReviews-showMore');
      var btn = showMore && (showMore.tagName === 'BUTTON' ? showMore : showMore.querySelector('button'));
      var target = btn || showMore;
      if (target && !target.disabled) {
        target.click();
        setTimeout(runWhenFeraReady, 800);
      }
    });
  }

  function runWhenFeraReady() {
    injectFeraGridStyles();
    removeLowRatedFeraReviews();
    clickShowMoreIfNeeded();
  }

  // Run as soon as possible (DOM may already have Fera content)
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', runWhenFeraReady);
  } else {
    runWhenFeraReady();
  }

  // Retry a few times for delayed Fera injection (e.g. 0.5s, 1.5s, 3s)
  [500, 1500, 3000].forEach(function (ms) {
    setTimeout(runWhenFeraReady, ms);
  });

  // Watch for Fera injecting the reviews container or new reviews
  var observer = new MutationObserver(function (mutations) {
    var shouldRun = mutations.some(function (m) {
      return [].some.call(m.addedNodes || [], function (node) {
        if (node.nodeType !== 1) return false;
        return node.classList && (
          node.classList.contains('fera-productReviews-reviews') ||
          node.classList.contains('fera-productReviews-review') ||
          node.querySelector && node.querySelector('.fera-productReviews-reviews, .fera-productReviews-review')
        );
      });
    });
    if (shouldRun) {
      runWhenFeraReady();
    }
  });

  observer.observe(document.documentElement || document.body, {
    childList: true,
    subtree: true
  });
})();
